import { create } from 'zustand';
import { persist, createJSONStorage, devtools } from 'zustand/middleware';

const defaultUserState = {
  userId: null,
  userType: null,
  userName: null,
};

export const useUserStore = create(
  devtools(
    persist(
      (set) => ({
        ...defaultUserState,

        setUserId: (userId) => set({ userId }),
        setUserType: (userType) => set({ userType }),
        setUserName: (userName) => set({ userName }),

        resetUserState: () => set(defaultUserState),
      }),
      {
        name: 'user-storage',
        storage: createJSONStorage(() => localStorage),
      }
    ),
    { name: 'User Store' }
  )
);
